export var REGION_GLOBAL = '-Global-';